@if (sectionHeader) {
  <h4 class="section-header">{{ sectionHeader }}</h4>
}
<div [class]="containerClass">
  <div class="form-group">
    <small class="text-muted">
      {{ hint }}
      @if (searchingProducts) {
        <fa-icon icon="spinner" animation="spin" class="m-r-10"></fa-icon>
      }
    </small>
    <div class="d-flex align-items-center">
      <input class="form-control m-r-5" [disabled]="disabled" [(ngModel)]="productQuery" [placeholder]="searchPlaceholder" (keyup.enter)="productAutocomplete()" />
      <button type="button" class="btn btn-primary" [disabled]="disabled || searchingProducts || !productQuery" (click)="productAutocomplete()">
        <fa-icon [icon]="searchingProducts ? 'spinner' : 'search'" [animation]="searchingProducts ? spinAnimation : undefined"></fa-icon>
      </button>
    </div>
    @if (productQuery && productResults && !productResults.length && !searchingProducts) {
      <small class="text-muted d-block m-t-5">No products found matching "{{ productQuery }}".</small>
    }
  </div>

  @if (productQuery && productResults && productResults.length) {
    @if (showProductLineSwitch && hasFenderResults) {
      <div class="m-b-10">
        <strong>
          <myp-switch [active]="associateWithProductLine" [label]="productLineSwitchLabel" [labelToRight]="true" (toggle)="onProductLineToggle()"></myp-switch>
        </strong>
        <div class="text-muted t-12 m-t-5">{{ productLineSwitchHelp }}</div>
      </div>
    }
    <div class="product-results trans-bg border-radius10 p-10" [ngClass]="resultListClass">
      @for (product of productResults; track product.id) {
        <myp-list-item
          [title]="product.title"
          [subData]="subDataMode === 'id' ? [product.id != null ? 'ID: ' + product.id : ''] : [product.DTYPE || product.categoryId]"
          [includeChevron]="false"
          [showImage]="false"
        >
          <div class="button-content">
            <fa-icon icon="plus" placement="left" [ngbTooltip]="addTooltip" (click)="selectProduct(product)" class="action green circle-icon-btn m-r-10"></fa-icon>
          </div>
        </myp-list-item>
      }
    </div>
  }

  @if (products?.length) {
    <div [class]="selectedListClass">
      @if (selectedHeader) {
        <span class="t-14 gothic">{{ selectedHeader }}</span>
      }
      @for (product of products; track product.id) {
        <myp-list-item
          [title]="product.title"
          [subData]="subDataMode === 'id' ? [product.id != null ? 'ID: ' + product.id : ''] : [product.DTYPE || product.categoryId]"
          [includeChevron]="false"
          [showImage]="false"
        >
          <div class="button-content">
            <fa-icon
              [icon]="removeBusyMap[product.id] ? 'spinner' : 'minus'"
              [animation]="removeBusyMap[product.id] ? spinAnimation : undefined"
              placement="left"
              [ngbTooltip]="removeTooltip"
              (click)="removeProduct(product)"
              class="action red circle-icon-btn m-r-10"
            ></fa-icon>
          </div>
        </myp-list-item>
      }
    </div>
  }

  @if (associatingProduct) {
    <div class="p-10 secondary-content-bg border-radius10 m-t-10">
      <fa-icon icon="spinner" animation="spin" class="m-r-5"></fa-icon>
      {{ associatingMessagePrefix }} {{ associatingProduct.title }}...
    </div>
  }
</div>
